var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEgypt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_167_8264)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 19.9999C16.0228 19.9999 20.5 15.5227 20.5 9.99988C20.5 4.47703 16.0228 -0.00012207 10.5 -0.00012207C4.97715 -0.00012207 0.5 4.47703 0.5 9.99988C0.5 15.5227 4.97715 19.9999 10.5 19.9999Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5001 -3.05176e-05C6.20043 -3.05176e-05 2.535 2.71372 1.12207 6.52173H19.8781C18.4652 2.71372 14.7997 -3.05176e-05 10.5001 -3.05176e-05Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5001 20C14.7997 20 18.4652 17.2862 19.8781 13.4782H1.12207C2.535 17.2862 6.20043 20 10.5001 20Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.978 8.913H11.3693C11.3693 8.43276 10.98 8.04343 10.4998 8.04343C10.0195 8.04343 9.6302 8.43276 9.6302 8.913H7.02148C7.02148 9.39327 7.4398 9.78257 7.92004 9.78257H7.89105C7.89105 10.2628 8.28035 10.6521 8.76063 10.6521C8.76063 11.1324 9.14992 11.5217 9.6302 11.5217H11.3693C11.8496 11.5217 12.2389 11.1324 12.2389 10.6521C12.7192 10.6521 13.1085 10.2628 13.1085 9.78257H13.0795C13.5598 9.78257 13.978 9.39327 13.978 8.913Z",
    fill: "#FF9811"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_167_8264"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEgypt);
export default __webpack_public_path__ + "static/media/egypt.bce1b12846b46dd594bf1b5feff11ff4.svg";
export { ForwardRef as ReactComponent };